import { Section } from "@akin2unde/flowui-react";
import type { ReactNode } from "react";
/** Consistent, keyboard-accessible form grouping backed by FlowUI Section. */
export default function EditorSection({title, children, className = ""}: {title: ReactNode; children: ReactNode; className?: string}) {
  return <Section title={title} defaultOpen className={`admin-section ${className}`}>{children}</Section>;
}
